<template>
  <div v-if="item">
    <!-- <div :style="indent" v-if="item != undefined" @click="toggleChildren">
      {{ item.name }}
    </div> -->
    <draggable class="spis-megawrapper" v-if="item.item != undefined">
      <div
        v-if="item.item.folder != undefined"
        class="inside-folder fold-to-click"
        :class="depth > 0 ? 'inside-folder-folder' : ''"
        :style="indent"
        :id="'folder-' + item.item.id"
        @click="toggleChildren(item.item)"
        @dragover="folderHover(item.item, '#folder-' + item.item.id)"
        @dragleave="folderHover(null, '#folder-' + item.item.id)"
        @dragend="moveFile(item.item)"
      >
        <div class="inside-folder-left">
          <div class="inside-folder-icon spis-folder">
            <img class="doc-icon" src="@/assets/img/folder_icon.svg" />
          </div>
          <div class="inside-folder-txts">
            <div class="inside-folder-title">
              {{ getFolderName(item.item.name) }}
            </div>
            <div class="detalji-spisa-tiny">
              <span class="tezina">{{ item.item.size / 1000000 }}mb</span>
            </div>
          </div>
        </div>
        <div class="inside-folder-right">
          <div class="ordinal">
            {{
              item.item.folder != undefined ? item.item.folder.childCount : ""
            }}
          </div>
          <div class="date">{{ formatDate(item.item.createdDateTime) }}</div>
          <div class="view" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="14"
              viewBox="0 0 24 14"
            >
              <g>
                <g>
                  <path
                    fill="#a2a4b0"
                    d="M23.885 6.475a.942.942 0 0 1 0 1.125c-3.044 4.04-7.17 6.528-11.72 6.528-4.55 0-8.675-2.488-11.72-6.533a.942.942 0 0 1 0-1.125C3.49 2.43 7.615-.059 12.165-.059c4.55 0 8.676 2.488 11.72 6.534zm-6.722.886A5.01 5.01 0 0 0 11.84 2.04c-2.494.156-4.516 2.176-4.671 4.669a5.01 5.01 0 0 0 5.324 5.32c2.489-.16 4.51-2.18 4.671-4.668zm-4.822 2.361A2.692 2.692 0 0 1 9.476 6.86a2.708 2.708 0 0 1 2.519-2.517 2.692 2.692 0 0 1 2.864 2.862 2.708 2.708 0 0 1-2.518 2.517z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div
            v-if="is_editable"
            @click.stop="handleFolderCreateFromFolder(item.item)"
            class="add-folder"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="22"
              viewBox="0 0 28 22"
              class="folder-svg"
            >
              <g>
                <g>
                  <path
                    fill="#b1b3bd"
                    d="M27.721 6.067v13.471A2.46 2.46 0 0 1 25.286 22H2.555A2.46 2.46 0 0 1 .12 19.538V3.291A2.46 2.46 0 0 1 2.555.827h9.02a.338.338 0 0 1 .27.122l2.232 2.657h11.209a2.46 2.46 0 0 1 2.435 2.461zm-8.74 6.633a.979.979 0 0 0-.978-.978h-3.105V8.616a.979.979 0 0 0-1.955 0v3.106H9.838a.979.979 0 0 0 0 1.956h3.105v3.106c0 .539.438.978.977.978.54 0 .978-.44.978-.978v-3.106h3.105c.539 0 .977-.439.977-.978z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div class="inside-folder-more" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="5"
              height="20"
              viewBox="0 0 5 20"
            >
              <g>
                <g>
                  <path
                    fill="#2b2a40"
                    d="M2.086 0a2.086 2.086 0 1 1 0 4.172 2.086 2.086 0 0 1 0-4.172z"
                  />
                </g>
                <g>
                  <path
                    fill="#2b2a40"
                    d="M2.086 7.823a2.086 2.086 0 1 1 0 4.172 2.086 2.086 0 0 1 0-4.172z"
                  />
                </g>
                <g>
                  <path
                    fill="#2b2a40"
                    d="M2.086 15.124a2.086 2.086 0 1 1 0 4.172 2.086 2.086 0 0 1 0-4.172z"
                  />
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
      <div
        v-else
        class="inside-folder inside-folder-right"
        :id="'single-file-' + item.item.id"
        :style="indent"
        @click.left.exact="handleClick(item.item)"
        @click.left.shift.exact="setMultiFileSelection(item.item)"
        @click.left.ctrl.exact="setMultiFileSelection(item.item)"
        @dblclick="handleDblClick(item.item)"
        @dragstart="handleClassClick(item.item)"
        @dragend="moveFile(item.item)"
        v-bind:class="[
          item.item.size / 1000000 > 0 == 1 ? '' : 'corrupted-file',
        ]"
      >
        <div class="inside-folder-left inside-folder-draft">
          <row-file-icon :file="item.item" :tag="taggable_flag"/>
          <div class="inside-folder-txts">
            <div class="inside-folder-title">
              {{ item.item.name }}
              <span class="draft"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <g>
                    <g>
                      <path
                        fill="#fd4087"
                        d="M10.613 10.98a.59.59 0 0 1-.59.59c-.782-.033-.782-1.148 0-1.18a.59.59 0 0 1 .59.59zm9.434-6.256c-.165 4.484-2.335 15.472-10.023 15.37C2.35 20.207.16 9.21 0 4.723c1.932.002 3.67.133 5.49-.73C7.389 3.198 8.652 1.596 10.024.12l1.646 1.78c1.616 1.763 3.897 2.83 6.27 2.823zm-4.36 6.256c-3.331-5.466-7.98-5.49-11.326 0 3.169 5.244 7.741 5.584 11.142.303zm-5.663-2.954c2.015 0 3.702 2.145 4.267 2.954-2.76 3.9-5.767 3.911-8.535-.001 1.077-1.594 2.842-3.007 4.268-2.953zm1.77 2.954c-.098-2.346-3.443-2.347-3.54 0 0 .975.794 1.768 1.77 1.768.975 0 1.77-.793 1.77-1.768z"
                      />
                    </g>
                  </g></svg></span>
            </div>
            <div class="detalji-spisa-tiny">
              <span class="tezina" v-if="item.item.size / 1000000 > 0"
                >{{ item.item.size / 1000000 }}mb</span
              >
              <span class="tezina" v-else>{{ $t('components.general.file_management.tree_menu.empty_or_invalid_file') }}</span>
            </div>
          </div>
        </div>
        <div class="inside-folder-right">
          <div v-if="taggable_flag" :key="item.item.id">
            <SingleFileTagSwitch :file="item.item"></SingleFileTagSwitch>
          </div>
          <div
            class="view"
            v-if="is_shared()"
            @click.prevent="handleShareTrigger(item.item.id)"
          ></div>

          <!-- <div class="ordinal">1</div> -->
          <div
            class="view"
            @click.stop="setStyling"
            v-if="item.item.size / 1000000 > 0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="14"
              viewBox="0 0 24 14"
            >
              <g>
                <g>
                  <path
                    fill="#a2a4b0"
                    d="M23.885 6.475a.942.942 0 0 1 0 1.125c-3.044 4.04-7.17 6.528-11.72 6.528-4.55 0-8.675-2.488-11.72-6.533a.942.942 0 0 1 0-1.125C3.49 2.43 7.615-.059 12.165-.059c4.55 0 8.676 2.488 11.72 6.534zm-6.722.886A5.01 5.01 0 0 0 11.84 2.04c-2.494.156-4.516 2.176-4.671 4.669a5.01 5.01 0 0 0 5.324 5.32c2.489-.16 4.51-2.18 4.671-4.668zm-4.822 2.361A2.692 2.692 0 0 1 9.476 6.86a2.708 2.708 0 0 1 2.519-2.517 2.692 2.692 0 0 1 2.864 2.862 2.708 2.708 0 0 1-2.518 2.517z"
                  />
                </g>
              </g>
            </svg>
          </div>

          <div class="date">{{ formatDate(item.item.createdDateTime) }}</div>
          <div
            v-if="is_editable && item.item.size / 1000000 > 0"
            @click.stop="handleFolderCreateFromFile(item.item)"
            class="add-folder"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="22"
              viewBox="0 0 28 22"
              class="folder-svg"
            >
              <g>
                <g>
                  <path
                    fill="#b1b3bd"
                    d="M27.721 6.067v13.471A2.46 2.46 0 0 1 25.286 22H2.555A2.46 2.46 0 0 1 .12 19.538V3.291A2.46 2.46 0 0 1 2.555.827h9.02a.338.338 0 0 1 .27.122l2.232 2.657h11.209a2.46 2.46 0 0 1 2.435 2.461zm-8.74 6.633a.979.979 0 0 0-.978-.978h-3.105V8.616a.979.979 0 0 0-1.955 0v3.106H9.838a.979.979 0 0 0 0 1.956h3.105v3.106c0 .539.438.978.977.978.54 0 .978-.44.978-.978v-3.106h3.105c.539 0 .977-.439.977-.978z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div v-if="item.item.size / 1000000 === 0" class="add-folder">
            <svg
              width="28"
              height="22"
              viewBox="4 0 18 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.49992 1.83325C5.31448 1.83325 4.33325 2.66352 4.33325 3.66659V18.3333C4.33325 19.3363 5.31448 20.1666 6.49992 20.1666H19.4999C20.6854 20.1666 21.6666 19.3363 21.6666 18.3333V7.33325L15.1666 1.83325H6.49992ZM6.49992 3.66659H14.0833V8.24992H19.4999V18.3333H6.49992V3.66659Z"
                fill="#B1B3BD"
              />
              <path
                d="M14.1108 8.27273L13.9148 14.3281H12.1634L11.9673 8.27273H14.1108ZM13.0369 17.1236C12.733 17.1236 12.4716 17.0156 12.2528 16.7997C12.0369 16.5838 11.929 16.3224 11.929 16.0156C11.929 15.7145 12.0369 15.4574 12.2528 15.2443C12.4716 15.0284 12.733 14.9205 13.0369 14.9205C13.3295 14.9205 13.5866 15.0284 13.8082 15.2443C14.0327 15.4574 14.1449 15.7145 14.1449 16.0156C14.1449 16.2202 14.0923 16.4062 13.9872 16.5739C13.8849 16.7415 13.75 16.875 13.5824 16.9744C13.4176 17.0739 13.2358 17.1236 13.0369 17.1236Z"
                fill="#B1B3BD"
              />
            </svg>
          </div>
          <div class="inside-folder-more" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="5"
              height="20"
              viewBox="0 0 5 20"
            >
              <g>
                <g>
                  <path
                    fill="#2b2a40"
                    d="M2.086 0a2.086 2.086 0 1 1 0 4.172 2.086 2.086 0 0 1 0-4.172z"
                  />
                </g>
                <g>
                  <path
                    fill="#2b2a40"
                    d="M2.086 7.823a2.086 2.086 0 1 1 0 4.172 2.086 2.086 0 0 1 0-4.172z"
                  />
                </g>
                <g>
                  <path
                    fill="#2b2a40"
                    d="M2.086 15.124a2.086 2.086 0 1 1 0 4.172 2.086 2.086 0 0 1 0-4.172z"
                  />
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </draggable>
    <div v-show="showChildren">
      <div v-if="isLoading()" class="new-spis-wrapper">
        <div class="new-spis-element">
          <div class="elastic-wrapp">
            <div class="dot-elastic"></div>
          </div>
        </div>
      </div>
      <div v-else>
        <tree-menu
          v-for="(node, key) in item.children"
          :key="key"
          :is_editable="is_editable"
          @show-children="sendShowChildren"
          :item="node"
          :depth="depth + 1"
          :accessToken="accessToken"
          @node-click="handleClick"
          @node-dblclick="handleDblClick"
          @node-drag="handleClassClick"
          @multi-select="setMultiFileSelection"
          @folder-create="handleFolderCreateFromFile"
          @folder-add="handleFolderCreateFromFolder"
          @folder-hover="folderHover"
          @file-move="moveFile"
          @share-file="handleShareTrigger"
        >
        </tree-menu>
      </div>
    </div>
  </div>
</template>

<script>
import share from "@/apiCallers/promise_handler_db/sharepoint";
import moment from "moment";
import draggable from "vuedraggable";
import SingleFileTagSwitch from "../fileManagement/SingleFileTagSwitch.vue";

import $ from "jquery";
import RowFileIcon from '../fileManagement/Icons/RowFileIcon.vue';
export default {
  props: [
    "item",
    "depth",
    "accessToken",
    "smjer",
    "is_editable",
    "tagged_files",
  ],
  name: "tree-menu",
  components: {
    draggable,
    SingleFileTagSwitch,
    RowFileIcon
  },
  data() {
    return { showChildren: false, trigg: false, loop_docs: [] };
  },

  computed: {
    indent() {
      var sirina = 100 - this.depth * 5 + "%";
      return { width: sirina };
    },
    taggable_flag(){
      console.log("current path",this.$router["currentRoute"].path)
      return this.$router["currentRoute"].path.includes("spisi")
    }
  },
  methods: {
    is_shared() {
      console.log(
        this.$store.state.current_selected_case,
        "current_selected_case"
      );
      if (!this.$store.state.current_selected_case) {
        return false;
      }
      if (this.item.item != undefined) {
        return (
          this.$store.state.current_selected_case.client_portal_shared_file.filter(
            (p) => p.item_id == this.item.item.id
          ).length > 0
        );
      } else {
        return false;
      }
    },



    getFolderName(name) {
      switch (name.trim()) {
        case "Ulazni dokumenti":
        case "Ulazna pošta":
          return this.$t("page_2.page_2_5.fold_1");
        case "Izlazni dokumenti":
        case "Izlazna pošta":
          return this.$t("page_2.page_2_5.fold_2");
        case "Radni dokumenti":
          return this.$t("page_2.page_2_4.fold_2");
        case "Popratni dokumenti":
          return this.$t("page_2.page_2_4.fold_3");
        case "Naplata":
          return this.$t("page_2.page_2_7.fold_1");
        case "Računi":
          return this.$t("page_2.page_2_7.fold_2");
        default:
          return name;
      }
    },
    isLoading() {
      if (this.item.item.folder != undefined) {
        console.log(this.item);
        return (
          this.item.children.length == 0 && this.item.item.folder.childCount > 0
        );
      } else {
        return false;
      }
    },
    setStyling() {
      this.$store.state.spis_active_pic = this.item.item;
      this.$store.state.spis_overlay_open = true;
    },
    moveFile(file_item) {
      if (this.is_editable) {
        this.$emit("file-move", file_item);
      }
    },
    createNewFolder(selectedDoc) {
      var direcNameArray = selectedDoc.name.split(".");
      var tmpDirName = "";
      for (var i = 0; i < direcNameArray.length - 1; i++) {
        tmpDirName = tmpDirName + direcNameArray[i];
      }
      var tmpDirLocationId = selectedDoc.parentReference.id;
      this.createFoldToParrent(tmpDirLocationId, tmpDirName, selectedDoc);
    },
    createFoldToParrent(parrentId, docname, dItem) {
      share
        .createFolderDocs(
          this.accessToken,
          this.$route.params.uid,
          parrentId,
          docname
        )
        .then((resp) => {
          // console.log(dItem);

          var path = "/drive/items/" + dItem.id;
          var tmpDriveItem = {
            parentReference: {
              id: resp.data.id,
            },
            name: dItem.name,
          };

          share.moveDriveItem(
            this.accessToken,
            this.$route.params.uid,
            resp.data.id,
            path,
            tmpDriveItem
          );
          this.reset;
        });
    },
    formatDate(datum) {
      return moment(datum.toString()).format("DD.MM.YYYY. HH:mm");
    },
    openFile(linkToFile) {
      window.open(linkToFile);
    },
    handleDblClick(node) {
      this.$emit("node-dblclick", node);
    },

    toggleChildren(selItem) {
      this.showChildren = !this.showChildren;
      this.handleClick(selItem);
      this.sendShowChildren(this.item.item.id);
    },
    handleClick(node) {
      $(".eye_clicked").removeClass("eye_clicked");
      $("#single-file-" + node.id).addClass("eye_clicked");
      this.$emit("node-click", node);
    },
    handleClassClick(node) {
      this.$emit("node-drag", node);
    },
    setMultiFileSelection(node) {
      $("#single-file-" + node.id).addClass("eye_clicked");
      this.$emit("multi-select", node);
    },
    handleFolderCreateFromFile(node) {
      this.$emit("folder-create", node);
    },
    handleShareTrigger(node) {
      console.log(node, "share-file");
      this.$emit("share-file", node);
    },
    handleFolderCreateFromFolder(node) {
      this.$emit("folder-add", node);
    },
    folderHover(node, setId) {
      if (node != null) {
        $(setId).addClass("hovered-folder");
      } else {
        $(setId).removeClass("hovered-folder");
      }
      this.$emit("folder-hover", node);
    },
    sendShowChildren(node) {
      this.$emit("show-children", node);
    },
  },
  watch: {
    "$store.state.all_files_tags": {
      handler: function () {
        console.log("Changes in store", this.$store.state.all_files_tags);
        if (!this.$store.state.all_files_tags) {
          console.log("changes are made", this.$store.state.all_files_tags);
        }
      },
    },
  },

  mounted() {
    console.log(
      "item opened status",
      this.item.item.opened,
      this.item.opened,
      this.depth
    );
    console.log("All tags", this.$store.state.all_files_tags);
    // if (parseInt(this.depth+1) = 1) {
    this.showChildren = this.item.item.opened;

    // }
    $(".fold-to-click").click(function () {
      $(".eye_clicked").removeClass("eye_clicked");
    });
  },
  destroyed() {
    $(".inside-folder").off();
    $(".fold-to-click").off();
  },
};
</script>
